export default __webpack_public_path__ + "static/media/Bb_minor.9bdc2053.jpg";